import { useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import FileUploader from "../components/FileUploader";
import FileList from "../components/FileList";
import { FolderOpen } from "lucide-react";

export default function Library() {
  const { t } = useTranslation();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto" data-testid="library-page">
        <div className="font-mono-data text-[10px] tracking-[0.3em] uppercase text-amber-500 mb-2">
          {t("library.kicker", "Company Vault")}
        </div>
        <div className="flex items-center gap-3 mb-2">
          <FolderOpen className="w-8 h-8 text-amber-500" />
          <h1 className="font-display text-5xl">{t("library.title", "Media Library")}</h1>
        </div>
        <p className="text-text-secondary mb-8">
          {t("library.subtitle", "Private file locker. Only members of your company can access these files.")}
        </p>

        <div className="tray p-6 mb-6">
          <div className="font-mono-data text-[10px] tracking-widest uppercase text-text-secondary mb-3">
            {t("library.uploadTitle", "Upload New File")}
          </div>
          <FileUploader
            scope="library"
            onUploaded={() => setRefreshKey(k => k + 1)}
            label={t("library.dropZone", "Drop a file or click to upload to your company library")}
          />
        </div>

        <div className="tray p-6">
          <div className="font-mono-data text-[10px] tracking-widest uppercase text-text-secondary mb-4">
            {t("library.filesTitle", "Company Files")}
          </div>
          <FileList
            scope="library"
            refreshKey={refreshKey}
            emptyLabel={t("library.empty", "No files in your company vault yet")}
          />
        </div>
      </div>
    </Layout>
  );
}
